import Model from '@/lib/data/Model';

class SurveyType extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'survey_type_name',
        'survey_type_tag',
        { name: 'legacy', type: 'bool', defaultValue: false },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'create',
            url: '/forms/type',
            associated: false,
        },
        {
            name: 'update',
            url: '/forms/type',
            associated: false,
        },
    ];
}

export default SurveyType;
